export default __webpack_public_path__ + "static/media/senior_adult.088f9e82.png";